/**
 * @Author: Jon Lucas
 * @Date:   2017-09-12T10:30:33+02:00
 * @Email:  jon.lucas@mazedia.fr
 * @Last modified by:   Jon Lucas
 * @Last modified time: 2017-09-25T18:02:29+02:00
 */

import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";

import { AbstractComponent } from "../../abstract-component/abstract.component";

import { BaseDataType } from "../../base-data-type";

import { ServiceLocator } from "../../service-locator";
import { LabelType } from "../../label-type";


export class AbstractViewComponent extends AbstractComponent {

    public readonly TAG: string = "[AbstractViewComponent]";

    public types: BaseDataType[];
    public selectedType: BaseDataType;

    protected router: Router;

    public validateLabel: LabelType;

    constructor(protected route: ActivatedRoute) {
        super();

        this.router = ServiceLocator.injector.get(Router);

        // this.router.events
        // .filter(event => event instanceof NavigationEnd)
        // .subscribe(this.navigationEventHandler.bind(this));
    }

    protected onClickValidate(e: MouseEvent): void
    {
        console.log(this.TAG, "onClickValidate()", e);

        console.log(this.TAG, this.route.snapshot);

        const commands: string[] = ["/lang", this.lang, this.route.snapshot.url[2].toString(), ""];

        this.router.navigate(commands);
    }

    protected navigationEventHandler(e: NavigationEnd = null): void {
        // this.route.paramMap.subscribe( params => {
        //     if(params.get('lang') == undefined)
        //     {
        //         return;
        //     }
        //     this.lang = params.get('lang');
        //     console.log("LANG", this.lang);
        //     if(this.types == undefined)  this.getTypes();
        // });
    }

    public onSelect(type: BaseDataType): void {
        this.selectedType = type;
    }

    public getData(): void {
        super.getData();
        // console.log(this.TAG, "getData()");
        // this.appService.getDatas().then(types => this.types = types);

        this.appService.getLabel("validate").then(
            label => this.validateLabel = label
        );
    }

    public ngOnInit(): void {
        this.route.paramMap.subscribe(params => {
            console.log(this.TAG, "params", params, this.route);
            if (!params.get("lang")) {
                this.lang = "fr";
            }
            this.lang = params.get("lang");
            // console.log(this.TAG, "LANG", this.lang);
            if (this.types === undefined)
            {
                this.getData();
            }
        });

        // this.navigationEventHandler();
    }

}



// WEBPACK FOOTER //
// ./src/app/main-view/abstract-view/abstract-view.component.ts